<div class="complete-details-banner pointer" (click)="bannerClick.emit()">
    <div class="complete-details-banner__inner large-wrapper">
        <div class="complete-details-banner__icon">
            <img alt="Action needed" src="assets/icons/require_account_details_icon.png" />
        </div>

        <div class="complete-details-banner__content">
            <div class="complete-details-banner__title">
                {{ lang.data['account.complete_details.banner_title'] || 'Action needed' }}
            </div>

            <div class="complete-details-banner__description">
                {{ lang.data['account.complete_details.banner_description'] || 'Complete your account details' }}
            </div>
        </div>
    </div>
</div>
